import { render, staticRenderFns } from "./AddEditRestrictedArea.vue?vue&type=template&id=76e9f864&scoped=true"
import script from "./AddEditRestrictedArea.vue?vue&type=script&lang=js"
export * from "./AddEditRestrictedArea.vue?vue&type=script&lang=js"
import style0 from "./AddEditRestrictedArea.vue?vue&type=style&index=0&id=76e9f864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9f864",
  null
  
)

export default component.exports